export default __webpack_public_path__ + "static/media/genericInsurance2.0a7fd2bb.png";